import React from 'react';
import { formatAccounting } from './boardPackHelpers';

// 100% mix visualization for a summary row/bucket: how much of the movement is an
// open anomaly vs dispositioned/expected vs ordinary/no-signal, with abs-dollar values.
// Answers "how much of this change is anomalous vs known/expected vs ordinary?" at a glance.
const SEGMENT_CLASS = {
  anomalous: 'bp-mix-seg--anomalous',
  dispositioned: 'bp-mix-seg--dispositioned',
  ordinary: 'bp-mix-seg--ordinary'
};

export default function SignalMixBar({ mix, compact = false }) {
  const segments = (mix?.segments || []).filter((segment) => segment.value > 0.0001);
  if (!segments.length) {
    return <p className="bp-muted bp-mix-empty">No signal decomposition for this bucket.</p>;
  }
  return (
    <div className={`bp-signal-mix${compact ? ' bp-signal-mix--compact' : ''}`}>
      <div className="bp-mix-track" role="img" aria-label="Signal mix by dollar impact">
        {segments.map((segment) => (
          <span
            key={segment.id}
            className={`bp-mix-seg ${SEGMENT_CLASS[segment.id] || ''}`}
            style={{ width: `${Math.max(segment.pct, 1.5)}%` }}
            title={`${segment.label}: ${formatAccounting(segment.value)} (${segment.pct.toFixed(0)}%)`}
          />
        ))}
      </div>
      {!compact && (
        <ul className="bp-mix-legend">
          {segments.map((segment) => (
            <li key={segment.id}>
              <span className={`bp-mix-dot ${SEGMENT_CLASS[segment.id] || ''}`} aria-hidden />
              <span className="bp-mix-legend-label">{segment.label}</span>
              <span className="bp-mono bp-mix-legend-value">
                {formatAccounting(segment.value)} · {segment.pct.toFixed(0)}%
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
